import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,

  authDomain: "vocabrun.firebaseapp.com",  
  storageBucket: "vocabrun.firebasestorage.app",
  messagingSenderId: "953613120687",
  appId: "1:953613120687:web:761174eaf2e5ce5bf8d05a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app, 'vocabdb');

export default app;
